import axios from 'axios';
import type { FfuImportProgress } from '@shared/helpers/ffu-import-progress.helpers';
import type { ProjectFileBatchSnapshot } from '@shared/models/project-file-batch.model';
import type { ProjectFileClientUpload } from '@client/helpers/project-file-upload-normalize.helpers';

/** FFU baseline POC: FFUs on their way to a project (admins only for now). */
export const ffuImportApi = {
  list: () =>
    axios
      .get<FfuImportProgress[]>('/project-file-batches/imports')
      .then((r) => r.data),

  /**
   * Starts the FFU pipe; the batch creates its project when it is done.
   * Returns the new batch's id.
   */
  start: async (
    uploads: readonly ProjectFileClientUpload[],
  ): Promise<string> => {
    const form = new FormData();
    for (const upload of uploads) {
      form.append('files', upload.file, upload.relativePath);
    }
    form.append('createProject', 'true');
    const response = await axios.post<ProjectFileBatchSnapshot>(
      '/project-file-batches',
      form,
    );
    return response.data.batch.id;
  },

  /** Tries a failed import again; the import may move to a new batch. */
  retry: (batchId: string) =>
    axios
      .post<FfuImportProgress>(`/project-file-batches/imports/${batchId}/retry`)
      .then((r) => r.data),

  /** Gives up on an import. The batch stays, it just makes no project. */
  abandon: async (batchId: string): Promise<void> => {
    await axios.delete(`/project-file-batches/imports/${batchId}`);
  },
};
